import { useState } from 'react';
import type { ICustomControlDiagnosticReportReadProps } from '../../interfaces';
import type { ISupervisionControlData } from '../../TOC/v1/supervisionControlData';
import { translateKey } from '../../../../../translate';
import { FormDivider } from '../../../../elements/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { initialSupervisionData } from '../../TOC/v1/types';
import { TooV1SupervisionReadFields } from './TooV1SupervisionReadFields';

export function TooV1SupervisionReadDraft(props: ICustomControlDiagnosticReportReadProps): JSX.Element {
    const { diagnosticReport, process } = props;

    const [hasSupervision] = useState(diagnosticReport.customControlData.hasSupervisionFields);

    if (!hasSupervision) {
        return <></>;
    }

    const [supervisionControlData] = useState<ISupervisionControlData>(
        diagnosticReport.customControlData.supervision
            ? diagnosticReport.customControlData.supervision
            : initialSupervisionData
    );

    return (
        <>
            <FormDivider />
            <ProcessItemHeader
                isFirstItem={false}
                isItemOpen={true}
                process={process}
                title={translateKey('tooSupervision.feedbackTitle')}
            />
            <TooV1SupervisionReadFields {...supervisionControlData} />
        </>
    );
}
